import API from '../services/api';

const FALLBACK_COUNTIES = {
  CO: [
    'Adams', 'Arapahoe', 'Boulder', 'Broomfield', 'Denver', 'Douglas', 'El Paso',
    'Elbert', 'Jefferson', 'Larimer', 'Pueblo', 'Weld',
  ],
  FL: [
    'Brevard', 'Broward', 'Duval', 'Hillsborough', 'Lake', 'Miami-Dade',
    'Orange', 'Osceola', 'Palm Beach', 'Pinellas', 'Polk', 'Seminole',
  ],
};

const countyCache = new Map();

export async function getCountiesForState(stateCode) {
  const state = String(stateCode || '').trim().toUpperCase();
  if (!state) return [];
  if (countyCache.has(state)) return countyCache.get(state);

  try {
    const response = await API.get(`/company/service-counties/${encodeURIComponent(state)}`);
    const counties = (Array.isArray(response.data?.counties) ? response.data.counties : [])
      .map((county) => String(county || '').trim().replace(/\s+County$/i, ''))
      .filter(Boolean)
      .sort((a, b) => a.localeCompare(b));
    countyCache.set(state, counties);
    return counties;
  } catch (_error) {
    const fallback = FALLBACK_COUNTIES[state] || [];
    countyCache.set(state, fallback);
    return fallback;
  }
}
